import { render, staticRenderFns } from "./cpp1220Exam3Q7.vue?vue&type=template&id=95f43022&"
import script from "./cpp1220Exam3Q7.vue?vue&type=script&lang=js&"
export * from "./cpp1220Exam3Q7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
